import { HomeRoute, isWithinSection, LoginRoute, LogoutRoute, RegistrationRoute } from './RouteHelper';

/** The subset of `window` the auth-redirect handler needs; narrowed so it can be faked in tests. */
type AuthRedirectWindow = { location: { pathname: string; href: string } };

/**
 * Build the one-shot 401 handler that bounces to the login page.
 *
 * Several in-flight requests can 401 together (e.g. the account load and a page's API call on a
 * cold arrival). Re-assigning `location.href` would abort the already-started login navigation, so
 * only the first 401 initiates the redirect. The window and the "redirect started" side effect are
 * injected so the first-wins guard and the login-URL construction are unit-testable without a real
 * navigation. `onRedirectStarted` renders the login-redirect page over the current one.
 */
export function createAuthRedirect(win: AuthRedirectWindow, onRedirectStarted: () => void): () => void {
    let redirectStarted = false;
    return () => {
        const { pathname, href } = win.location;

        // Not from the login or register pages, which need no session, nor from logout, where a bounce would
        // return the customer to /logout after they log in and end the new session.
        if (
            isWithinSection(pathname, LoginRoute) ||
            isWithinSection(pathname, RegistrationRoute) ||
            isWithinSection(pathname, LogoutRoute)
        ) {
            return;
        }

        if (redirectStarted) return;
        redirectStarted = true;

        //on auth required, redirect to the login page
        console.log('authentication required, redirecting to login page');
        const login_page = new URL(LoginRoute, href);
        if (!isWithinSection(pathname, HomeRoute)) login_page.searchParams.append('r', href);
        win.location.href = login_page.href;

        onRedirectStarted();
    };
}
